import React from 'react'
import Markdown from 'react-markdown'
import clsx from 'clsx'
import Link from 'next/link'

type Props = {
  children: string
  className?: string
  target?: string
}

export default function NcMarkdown({
  children,
  target,
  className = '',
}: Props) {
  // noinspection JSUnusedGlobalSymbols
  return (
    <Markdown
      components={{
        ul: (props) => (
          <ul className="my-2 ml-8 flex list-disc flex-col gap-1 text-slate-700">
            {props.children}
          </ul>
        ),
        li: (props) => (
          <li>
            <span className="relative left-1">{props.children}</span>
          </li>
        ),
        a: (props) => (
          <Link
            className="text-decoration-none text-blue-600"
            href={props.href!!}
            target={target}
          >
            {props.children}
          </Link>
        ),
      }}
      className={clsx(className)}
    >
      {children}
    </Markdown>
  )
}
